import { ROLE } from "./constants";

export const ROUTES = {
  ROOT: "/",
  SIGN_IN: "/sign-in",
  INVITATION: "/Invitation",

  TENANTS_THERAPISTS: (tenantId: string) => `/tenants/${tenantId}/therapists`,
  TENANTS_INVITATIONS: (tenantId: string) => `/tenants/${tenantId}/invitations`,
  TENANTS_DASHBOARD: (tenantId: string) => `/tenants/${tenantId}/dashboard`,
  TENANTS_CLIENTS: (tenantId: string) => `/tenants/${tenantId}/clients`,
  TENANTS_HISTORY: (tenantId: string) => `/tenants/${tenantId}/history`,
  TENANTS_SETTINGS: (tenantId: string) => `/tenants/${tenantId}/settings`,

  CLIENTS_INVITATIONS: "/clients/invitations",
  OPEN_CLIENT: (clientId: string) => `/open-client/${clientId}`,
  CLIENT: (clientId: string) => `/clients/${clientId}`,
  CLIENT_PROFILE: (clientId: string) => `/clients/${clientId}/profile`,
  CLIENT_ANALYTICS: (clientId: string) => `/clients/${clientId}/analytics`,
  CLIENT_PERSONAL_PLAN: (clientId: string) => `/clients/${clientId}/personal-plan`,
  CLIENT_JOURNAL: (clientId: string) => `/clients/${clientId}/journal`,
  CLIENT_CONTENT: (clientId: string) => `/clients/${clientId}/content`,

  SETTINGS: "/settings",
  THERAPIST_MANAGEMENT: "/therapist-management",
} as const;

// Static route patterns used in <Route path="..."> (without leading slash for nested routes)
export const ROUTE_PATTERNS = {
  SIGN_IN: "/sign-in",
  INVITATION: "/Invitation",
  TENANTS_THERAPISTS: "/tenants/:tenantId/therapists",
  TENANTS_INVITATIONS: "/tenants/:tenantId/invitations",
  TENANTS_DASHBOARD: "/tenants/:tenantId/dashboard",
  TENANTS_CLIENTS: "/tenants/:tenantId/clients",
  TENANTS_HISTORY: "/tenants/:tenantId/history",
  TENANTS_SETTINGS: "/tenants/:tenantId/settings/*",
  CLIENTS_INVITATIONS: "/clients/invitations",
  OPEN_CLIENT: "/open-client/:clientId",
  SETTINGS: "/settings/*",
  THERAPIST_MANAGEMENT: "/therapist-management",
  CLIENT: "/clients/:clientId",

  // Client sub-routes (nested under CLIENT in App.js)
  CLIENT_PROFILE: "profile",
  CLIENT_ANALYTICS: "analytics",
  CLIENT_PERSONAL_PLAN: "personal-plan",
  CLIENT_JOURNAL: "journal",
  CLIENT_CONTENT: "content",
} as const;

export function getDefaultLandingRoute(
  role: string | undefined,
  isTenantSuperAdminInTherapistMode: boolean,
  tenantId: string,
): string {
  // Account Admin (super admin NOT in therapist mode) lands on All Therapists — the
  // first sidebar item for that mode (UP-3006). Everyone else lands on All Clients.
  if (role === ROLE.TENANT_SUPER_ADMIN && !isTenantSuperAdminInTherapistMode) {
    return ROUTES.TENANTS_THERAPISTS(tenantId);
  }
  return ROUTES.TENANTS_CLIENTS(tenantId);
}
